const accessAuth = {

    LOGIN: { name: 'Login', path: '/login' },
    LOGIN: { name: 'Login', path: '/' },

    UNKNOWN_PATH: { name: 'Unknown Path', path: '*' }

}

export default accessAuth;